export default {
    getOrganizationList:'/auth/organization/organizationList', //获取组织列表
    deleteOrg:'/auth/organization/deleteOrganization', //组织删除
    addOrg:'/auth/organization/addOrganization', //组织新增
    getCityList:'/auth/token/condition/cityCodeList', //获取城市
    updateOrg:'/auth/organization/updateOrganization', //组织新增
    
}


// WEBPACK FOOTER //
// ./src/api/organizationalManagement.js